import { Box, Grid, Button, TextField, Typography } from "@mui/material";
import { React, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sizes } from "./editScenarioNewUtils";
import {
  cloneScenario,
  saveScenario,
  setState,
  submitScenario,
  verifyScenario,
  reset,
  getScenario
} from "./editScenarioNewSlice";

import CheckIcon from "@mui/icons-material/Check";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import SaveIcon from "@mui/icons-material/Save";
import ExportExcelPDF from "./ExportExcelPDF";
import {
  setState as setStateCreate,
  getDataSources,
  getCustGrpRef,
  SearchScenarioName,
} from "../scenarioSetupNewSlice";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import moment from "moment";
import CollapseSection from "../../../../components/ui/CollapseSection";

const commonHeight = sizes.h35;
const LW = sizes.w500;

export default function Summary() {
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;

  const isRestrictedAccess = setAccess;
  const dispatch = useDispatch();
  const setupState = useSelector((store) => store.editScenarioNew);
  const setupStateCreate = useSelector((store) => store.scenarioSetupNew);
  const { editMode } = setupStateCreate;

  const {
    scenarioName,
    selectedCountry,
    createToDate,
    periodType,
    selectedPGs,
    selectedCustsCGs,
    customerBreakdownType,
    customerBreakdown,
    skuBreakdown,
    comments,
    selectedDSs,
    scDSA,
    dataSources,
    countryID,
    emailNotification,
    primaryDataSourceID,
    minimumQuota,
    editModeEdit,
    email,
    createFromDate,
    sentToSAP,
    DSMHigh,
    DSMMed,
    DSMLow,
    DSMOth,
    isCloneDisable,
    isButtonDisable,
    selectedPDS,
    editScDetails,
    editScID,
    selectedCLID,
    selectedScSTQ,
    scenarioStatus,
    SafetyMargin,
    criticalityId,
    selectedLinearTrend,
    selectedRunRate,
    selectedConsensus,
    selectedPreviousYear,
    quotaDeviationPercentage,
    modificationDeviationPercentage,
    selectedDefaultInitialForecast,
    editScDSAData,
    scenarioExternalDataSource,
    scenarioExternalDataSourceSKU,
    selectedReferenceSKU,
    MarketShareTimePeriod,
    marketShareComparisonList,
    manually_defineMSList,
    refList,
    sku_PG_Name,
    productGroups,
    selectedcustomerTypes,
    selectedCustType,
    selectedCTCode,
    selectedCL,
    breakDowns,
    selectedBD,
    breakDownTypes,
    selectedBDT,
    selectedTL,
    selectedTLID,
    customerName,
    custsCGs,
    selectedSKUBDM,
    selectedPG_SKU_ADSs,
    selectedPG_SKU_ADSsID,
    DSAData,
    scDSACopy,
    DSAIdString,
    DSAIdStringPrev,
    PreviousMarketShareTimePeriod,
    lstScenarioCustomers,
    lstScenarioCustomerGroups,
    lstScenarioSKUs,
    lstScenarioProducts,
    scenarioDataSourceAlignment,
    editScName,
    editScenarioList,
    message,
    severity,
    messageOpen,
    localForecastAlignment,
    previousSelectedReferenceSKU,
    previousMarketShareComparisonList,
    selectedRows,
    marketShareGraphData,
    previousMarketShareGraphData,
    criticalityList,
    isCopyDisable,
    isCustomerChanged,
    isCloneClicked,
    search_ScenarioName,
    search_FromDate,
    search_ToDate
  } = setupState;
  const [CustomerList, setCustomerList] = useState(
    selectedCustsCGs ? selectedCustsCGs : []
  );
  const [ProductList, setProductList] = useState(selectedPGs ? selectedPGs : []);
  const [isAscByName, setAscByName] = useState(false);
  const [isAscByNumber, setAscByNumber] = useState(false);
  const [isAscByNameSKU, setAscByNameSKU] = useState(false);
  const [isAscByNumberSKU, setAscByNumberSKU] = useState(false);
  useEffect(() => {
    setCustomerList(selectedCustsCGs ? selectedCustsCGs : []);
  }, [selectedCustsCGs]);

  useEffect(() => {
    setProductList(selectedPGs ? selectedPGs : []);
  }, [selectedPGs]);

  const listToNameString = (list, type) => {
    let nameString = "";

    let filteredList = [];
    if (type == "P")
      filteredList = list
        .filter(
          (item) => item.type === type || item.hasOwnProperty("productID")
        )
        .map((item) => (item.name ? item.name : item.productName));
    else if (type == "PG")
      filteredList = list
        .filter(
          (item) => item.type === type || item.hasOwnProperty("productGroupID")
        )
        .map((item) => (item.name ? item.name : item.productGroupName));
    else if (type == "C")
      filteredList = list
        .filter(
          (item) => item.type === type || item.hasOwnProperty("customerID")
        )
        .map((item) => (item.name ? item.name : item.customerName));
    else if (type == "CG")
      filteredList = list
        .filter(
          (item) => item.type === type || item.hasOwnProperty("customerGroupID")
        )
        .map((item) => (item.name ? item.name : item.customerGroupName));

    if (type != "C") nameString = filteredList.join(", ");
    else nameString = filteredList.join("\n");

    // for (let i = 0; i < list.length; ++i) {
    // 	const item = list[i];
    // 	if (item.type === type) {
    // 		nameString += `${item.name}, `;
    // 	}
    // }
    return nameString;
  };
  const listToNameStringCustomers = (list, type) => {
    let nameString = "";
    let listItems = JSON.parse(JSON.stringify(list));
    let filteredList = [];
    filteredList = listItems
      .filter((item) => item.type === type || item.hasOwnProperty("customerID"))
      .map((item) => (item.name ? item.name : item.customerName));

    nameString = filteredList.join("\n");
    return nameString;
  };

  const listToNameStringSKUs = (list, type) => {
    let nameString = "";
    let listItems = JSON.parse(JSON.stringify(list));
    let filteredList = [];
    filteredList = listItems
      .filter((item) => item.type === type || item.hasOwnProperty("productID"))
      .map((item) => (item.name ? item.name : item.productName));

    nameString = filteredList.join("\n");
    return nameString;
  };

  const getItemText = (item) => {
    if (item.hasOwnProperty("name")) {
      return item.name;
    } else if (item.hasOwnProperty("productGroupName")) {
      return item.productGroupName;
    } else if (item.hasOwnProperty("productName")) {
      return item.productName;
    } else if (item.hasOwnProperty("customerGroupName")) {
      return item.customerGroupName;
    } else if (item.hasOwnProperty("customerName")) {
      return item.customerName;
    }
  };
  const getItemNumber = (item) => {
    if (item.hasOwnProperty("id")) {
      return item.sapCustomerNumber ? item.sapCustomerNumber : item.cip;
    } else if (item.hasOwnProperty("productGroupID")) {
      return 0;
    } else if (item.hasOwnProperty("productID")) {
      return item.clientProductCode;
    } else if (item.hasOwnProperty("customerGroupID")) {
      return 0;
    } else if (item.hasOwnProperty("customerID")) {
      return item.sapCustomerNumber;
    }
  };
  const handleClick = (type) => {
    if (type === "name") {
      if (!isAscByName) {
        let list = JSON.parse(JSON.stringify(CustomerList));
        list = list.sort((a, b) =>
          getItemText(a).toLowerCase().trim() >
          getItemText(b).toLowerCase().trim()
            ? 1
            : -1
        );
        setCustomerList(list);
        setAscByName(true);
      } else {
        let list = JSON.parse(JSON.stringify(CustomerList));
        list = list.sort((a, b) =>
          getItemText(a).toLowerCase().trim() <
          getItemText(b).toLowerCase().trim()
            ? 1
            : -1
        );
        setCustomerList(list);
        setAscByName(false);
      }
    } else {
      if (!isAscByNumber) {
        let list = JSON.parse(JSON.stringify(CustomerList));
        list = list.sort((a, b) =>
          getItemNumber(a) > getItemNumber(b) ? 1 : -1
        );
        setCustomerList(list);
        setAscByNumber(true);
      } else {
        let list = JSON.parse(JSON.stringify(CustomerList));
        list = list.sort((a, b) =>
          getItemNumber(a) < getItemNumber(b) ? 1 : -1
        );
        setCustomerList(list);
        setAscByNumber(false);
      }
    }
  };

  const handleClickSKU = (type) => {
    if (type === "name") {
      if (!isAscByNameSKU) {
        let list = JSON.parse(JSON.stringify(ProductList));
        list = list.sort((a, b) =>
          getItemText(a).toLowerCase().trim() >
          getItemText(b).toLowerCase().trim()
            ? 1
            : -1
        );
        setProductList(list);
        setAscByNameSKU(true);
      } else {
        let list = JSON.parse(JSON.stringify(ProductList));
        list = list.sort((a, b) =>
          getItemText(a).toLowerCase().trim() <
          getItemText(b).toLowerCase().trim()
            ? 1
            : -1
        );
        setProductList(list);
        setAscByNameSKU(false);
      }
    } else {
      if (!isAscByNumberSKU) {
        let list = JSON.parse(JSON.stringify(ProductList));
        list = list.sort((a, b) =>
          getItemNumber(a) > getItemNumber(b) ? 1 : -1
        );
        setProductList(list);
        setAscByNumberSKU(true);
      } else {
        let list = JSON.parse(JSON.stringify(ProductList));
        list = list.sort((a, b) =>
          getItemNumber(a) < getItemNumber(b) ? 1 : -1
        );
        setProductList(list);
        setAscByNumberSKU(false);
      }
    }
  };

  const getDataSourcesString = () => {
    let dsString = "";
    dsString = selectedDSs.join(", ");
    // for (let i = 0; i < selectedDSs.length; ++i) {
    // 	dsString += `${selectedDSs[i]}, `;
    // }
    return dsString;
  };

  const handleStateUpdate = (event, stateName) => {
    const value = event.target.value;
    dispatch(setState(stateName, value));
  };

  const showMessage = (message, severity) => {
    dispatch(setState("message", message));
    dispatch(setState("severity", severity));
    dispatch(setState("messageOpen", true));
  };

  const validFromDate = (date) => {
    if(createFromDate == null || createFromDate == undefined || createFromDate == "") {
      showMessage("Please select the validity from date", "info");
      return false;
    }
    if (periodType.length <= 0) {
      showMessage("Please select period type first", "info");
      return false;
    }
    // if (periodType === "Weekly" && date.day() !== 1) {
    //   showMessage("Chosen day must be Monday for weekly period type", "info");
    //   return false;
    // }
    // if (periodType === "Monthly" && date.date() !== 1) {
    //   showMessage(
    //     "Chosen day must be first day of month for monthly period type",
    //     "info"
    //   );
    //   return false;
    // }
    // if (date < dayjs() && periodType === "Weekly") {
    //   showMessage("Past dates cannot be selected", "info");
    //   return false;
    // }
    // if (date < dayjs() && periodType === "Monthly") {
    //   showMessage("Past dates cannot be selected", "info");
    //   return false;
    // }
    if (date > createToDate) {
      showMessage("Invalid from date", "info");
      return false;
    }
    return true;
  };

  const validToDate = (date) => {
    if(createToDate == null || createToDate == undefined || createToDate == "") {
      showMessage("Please select the validity to date", "info");
      return false;
    }
    if (periodType.length <= 0) {
      showMessage("Please select period type first", "info");
      return false;
    }
    if (periodType === "Weekly" && date.day() !== 0) {
      showMessage("Chosen day must be Sunday for weekly period type", "info");
      return false;
    }
    if (periodType === "Monthly" && !date.isSame(date.endOf("month"), "day")) {
      showMessage(
        "Chosen day must be last day of month for monthly period type",
        "info"
      );
      return false;
    }
    if (date < dayjs()) {
      showMessage("Past dates cannot be selected", "info");
      return false;
    }
    if (date < createFromDate) {
      showMessage("Invalid To date", "info");
      return false;
    }
    return true;
  };

  const validDate = () => {
    return validFromDate(createFromDate) && validToDate(createToDate);
  };

  const submitDataIsValid = () => {
    console.log(selectedCountry);
    if (selectedCountry.length <= 0) {
      showMessage("Please select a country", "info");
      return false;
    }
    if (scenarioName.length <= 0) {
      showMessage("Please enter scenario name", "info");
      dispatch(setState("section_Scenario_Parameteres",true));
      return false;
    }
    if (periodType.length <= 0) {
      showMessage("Please select period type", "info");
      dispatch(setState("section_Scenario_Parameteres",true));
      return false;
    }
    if (periodType.length <= 0) {
      showMessage("Please select period type", "info");
      dispatch(setState("section_Scenario_Parameteres",true));
      return false;
    }
    if (!validDate()) {
      dispatch(setState("section_Scenario_Parameteres",true));
      return false;
    }
    const fromDate = dayjs(createFromDate).startOf("day");
    const toDate = dayjs(createToDate).startOf("day");

    if (toDate.diff(fromDate, "day") <= 7) {
       showMessage("Validity must be at least 7 days", "info");
       return;
    }
    if (selectedPGs.length <= 0) {
      showMessage("At least one SKU or Product Group must be selected", "info");
      dispatch(setState("section_SKU", true));
      return false;
    }
    if (selectedCustsCGs.length <= 0) {
      showMessage(
        "At least one Customer or Customer Group must be selected",
        "info"
      );
      dispatch(setState("section_Customer", true));
      return false;
    }
    if (selectedDSs.length <= 0) {
      showMessage("At least one Data Source must be selected", "info");
      dispatch(setState("section_Datasources", true));
      return false;
    }
    if (selectedPDS.length <= 0) {
      showMessage("Primary data source must be selected", "info");
      dispatch(setState("section_Datasources", true));
      return false;
    }
    if (criticalityId.length <= 0) {
      showMessage("Scenario Criticality must be selected", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if (selectedScSTQ.length <= 0) {
      showMessage("Scenario Stick to Quota must be selected", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if (skuBreakdown.length <= 0) {
      showMessage("SKU breakdown methodology must be selected", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if (customerBreakdownType.length <= 0) {
      showMessage("Customer breakdown type must be selected", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if (
      (customerBreakdownType == "Scenario SKUs" ||
        customerBreakdownType == "Reference SKUs" ||
        customerBreakdownType == "Dynamic Market Share") &&
      customerBreakdown === ""
    ) {
      showMessage("Customer breakdown period must be selected", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if (
      customerBreakdownType == "External" &&
      scenarioExternalDataSource.length <= 0
    ) {
      showMessage("Please upload External Market share for customers", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if (
      customerBreakdownType == "Manually Defined" && (isCustomerChanged === true ||
      manually_defineMSList.length <= 0 )
    ) {
      showMessage("Please upload Manually Defined share for customers", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if (
      customerBreakdownType == "Reference SKUs" &&
      selectedReferenceSKU.length <= 0 &&
      refList === ""
    ) {
      showMessage(
        "Reference SKU definition in Market share comparison is not available.",
        "info"
      );
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if (
      skuBreakdown == "External" &&
      scenarioExternalDataSourceSKU.length <= 0
    ) {
      showMessage("Please upload External Market share for SKUs", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if (selectedLinearTrend == "") {
      showMessage("Linear Trend should be selected", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if (selectedRunRate == "") {
      showMessage("Run Rate should be selected", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if (selectedConsensus == "") {
      showMessage("Forecast should be selected", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if (selectedPreviousYear == "") {
      showMessage("Previous Year should be selected", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    if (selectedDefaultInitialForecast == "") {
      showMessage("Default Initial Forecast should be selected", "info");
      dispatch(setState("section_Scenario_Settings", true));
      return false;
    }
    // let isBufferAdded = false;
    // for (let i = 0; i < selectedCustsCGs.length; i++) {
    //   if (selectedCustsCGs[i].hasOwnProperty("isBuffer")) {
    //     if (selectedCustsCGs[i].isBuffer === 1) {
    //       isBufferAdded = true;
    //       break;
    //     }
    //   }
    // }
    // if (!isBufferAdded) {
    //   showMessage("Please include a Buffer Customer in the Scenario", "info");
    //   return false;
    // }
    return true;
  };

  const getIDsFromList = (list, unit) => {
    console.log("Edit_Summary_getIDsFromList", list);
    let unitStr = "";
    let groupStr = "";
    const size = list.length;
    for (let i = 0; i < size; ++i) {
      if (
        list[i].hasOwnProperty("id") &&
        list[i].type != undefined &&
        list[i].type != null
      ) {
        if (list[i].type === unit) {
          unitStr += i === size - 1 ? list[i].id : list[i].id + ",";
        } else {
          groupStr += i === size - 1 ? list[i].id : list[i].id + ",";
        }
      } else if (list[i].hasOwnProperty("productID")) {
        unitStr += i === size - 1 ? list[i].productID : list[i].productID + ",";
      } else if (list[i].hasOwnProperty("customerID")) {
        unitStr +=
          i === size - 1 ? list[i].customerID : list[i].customerID + ",";
      } else if (list[i].hasOwnProperty("customerGroupID")) {
        groupStr +=
          i === size - 1
            ? list[i].customerGroupID
            : list[i].customerGroupID + ",";
      } else if (list[i].hasOwnProperty("productGroupID")) {
        groupStr +=
          i === size - 1
            ? list[i].productGroupID
            : list[i].productGroupID + ",";
      }
    }
    if (unitStr.endsWith(",")) unitStr = unitStr.slice(0, -1);
    if (groupStr.endsWith(",")) groupStr = groupStr.slice(0, -1);
    console.log("Edit_Summary_getIDsFromList", { unitStr, groupStr });
    return {
      unitStr,
      groupStr,
    };
  };

  const getPipeSeparatedString = (list) => {
    let str = "";
    for (let i = 0; i < list.length; ++i) {
      str += i === list.length - 1 ? list[i] : list[i] + "|";
    }
    return str;
  };

  const prepareScenarioDSAlignment = (prodObj) => {
    let scDSList = [];
    const groupIds = prodObj.groupStr.split(","); 
    const unitIds = prodObj.unitStr.split(",");
    if (scDSA.length > 0) {
      for (let i = 0; i < scDSA.length; ++i) {
        const item = scDSA[i];
        const id = selectedDSs.findIndex((x) => x === item.dataSourceName);
        if (id > -1) {
          const obj = {
            DataSourceID: item.dataSourceID,
            skuid: item.skuid,
            productGroupID: item.productGroupID,
            MeasureNumber: item.MeasureNumber,
          };
          const attributeList = item.attributes;
          for (let j = 0; j < attributeList.length; ++j) {
            const attrItem = attributeList[j];
            if (
              attrItem.attributeName !== "hide" &&
              attrItem.selectedAttributeValues.length > 0
            ) {
              const objPropName = `AttributeFilter${j + 1}`;
              const pipeSeparatedString = getPipeSeparatedString(
                attrItem.selectedAttributeValues
              );
              obj[objPropName] = pipeSeparatedString;
            }
          }
          scDSList.push(obj);
        }
      }
    } else if (editScDSAData.length > 0) {
      for (let i = 0; i < editScDSAData.length; ++i) {
        const item = editScDSAData[i];
        const id = selectedDSs.findIndex((x) => x === item.dataSourceName);
        let measureValue;
        if (item.measure.length > 0) {
          measureValue = item.measure[0].measureValue;
        }
        if (id > -1) {
          const obj = {
            DataSourceID: item.dataSourceID,
            skuid: item.skuid,
            productGroupID: item.productGroupID,
            MeasureNumber: measureValue,
          };
          const attributeList = item.attributes;
          for (let j = 0; j < attributeList.length; ++j) {
            const attrItem = attributeList[j];

            const objPropName = `AttributeFilter${j + 1}`;
            const pipeSeparatedString = attrItem.attributeValues[0];
            obj[objPropName] = pipeSeparatedString;
          }
          scDSList.push(obj);
        }
      }
    } else {
      for (let i = 0; i < selectedDSs.length; ++i) {
        const name = selectedDSs[i];
        const DataSourceID = dataSources.find(
          (source) => source.dataSourceName === name
        ).dataSourceID;
        const obj = {
          DataSourceID,
        };
        scDSList.push(obj);
      }
    }

    const filteredList = scDSList.filter(item => (item.skuid && unitIds.includes(item.skuid.toString())) ||
    (item.productGroupID && groupIds.includes(item.productGroupID.toString()))
    || (item.skuid === null && item.productGroupID === null));
    
    //|| groupIds.includes(item.productGroupID) );
    // const idx = selectedDSs.findIndex((x) => x === "Ex-Factory");
    // if (idx > -1) {
    //   const obj = {
    //     DataSourceID: 1,
    //   };
    //   scDSList.push(obj);
    // }
    for(let i= 0; i< selectedDSs.length; i++){
      const name = selectedDSs[i];
      const DataSourceID = dataSources.find(
          (source) => source.dataSourceName === name
      ).dataSourceID;
      const id = filteredList.findIndex((x) => x.DataSourceID === DataSourceID);
      if(id === -1){
        const obj = {
          DataSourceID,
        };
        filteredList.push(obj);
      }
    }
    return filteredList;
  };

  const changeDateFormat = (date) => {
    const year = date.year();
    const month =
      date.month() + 1 < 10 ? `0${date.month() + 1}` : date.month() + 1;
    const day = date.date() < 10 ? `0${date.date()}` : date.date();
    const time = "T00:00:00.000Z";
    const d = `${year}-${month}-${day}${time}`;
    return d;
  };
  const changeDateFormatforComments = () => {
    const date = new Date();
    const year = date.getYear() + 1900;
    const month =
      date.getMonth() + 1 < 10
        ? `0${date.getMonth() + 1}`
        : date.getMonth() + 1;
    const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const sec = date.getSeconds();
    const time = `T${hours}:${minutes}:${sec}.000Z`;
    const d = `${day}-${month}-${year}${time}`;
    return d;
  };
  const prepareManuallyDefinedShare = () => {
    let manually_define_MS_List = [];
    if (
      marketShareComparisonList != undefined &&
      marketShareComparisonList != null &&
      marketShareComparisonList.length > 0
    ) {
      for (let i = 0; i < marketShareComparisonList.length; i++) {
        let mdList = {};
        mdList.id = marketShareComparisonList[i].id;
        mdList.share = Number(marketShareComparisonList[i].manually_Defined_MS);
        mdList.name = marketShareComparisonList[i].name;
        mdList.type = marketShareComparisonList[i].type;
        manually_define_MS_List.push(mdList);
      }
    }
    return manually_define_MS_List;
  };

  const clearErrors = () =>{
    dispatch(setState("section_Scenario_Parameteres", false));
    dispatch(setState("section_SKU", false));
    dispatch(setState("section_Customer", false));
    dispatch(setState("section_Datasources", false));
    dispatch(setState("section_Scenario_Settings", false));
  }

  const handleSubmit = () => {
    clearErrors();
    if (!submitDataIsValid()) {
      return;
    }
    const CustObj = getIDsFromList(selectedCustsCGs, "C");
    const prodObj = getIDsFromList(selectedPGs, "P");
    const data = JSON.parse(localStorage.getItem("data"));
    const scDSList = prepareScenarioDSAlignment(prodObj);
    const manually_Defined = prepareManuallyDefinedShare();
    let referenceSKUList = "";
    if (selectedReferenceSKU.length === 0) {
      referenceSKUList = refList;
    } else {
      referenceSKUList = selectedReferenceSKU
        ?.filter((y) => y.id != 0)
        .map((x) => x.id)
        .join();
    }
    let userName = data.firstName + " " + data.lastName;
    let today = changeDateFormatforComments();
    let cmnts = comments;
    if (cmnts != undefined) {
      if (cmnts.indexOf(userName) <= 0)
        cmnts = cmnts + " (" + userName + ") " + today.toLocaleString();
    }
    debugger
    const editSubmitData = {
      scenarioID: editScID,
      countryID: countryID,
      scenarioName,
      primaryDataSourceID,
      periodType,
      minimumQuota: minimumQuota,
      customerBreakdownType: customerBreakdownType,
      customerBreakdown: customerBreakdown,
      skuBreakdown: skuBreakdown,
      defaultSafetyMargin: 0,
      isSendToSAPChecked: sentToSAP,
      sentToSAP: sentToSAP ? "N" : "NA",
      scenarioLevel: selectedCLID,
      displayStickToQuota: selectedScSTQ === "Enabled" ? 1 : 0,
      emailNotification,
      notificationEmailAddress: email,
      comments: cmnts,
      scenarioStatus,
      previousScenario: "",
      updatedBy: data.firstName + " " + data.lastName,
      updatedDate: changeDateFormat(dayjs()),
      createdBy: editScDetails.createdBy,
      createdDate: editScDetails.createdDate,
      approvedRejectedBy: editScDetails.approvedRejectedBy,
      SentToSAP4PLExport: sentToSAP ? 0 : 1,
      rejectionComments: editScDetails.rejectionComments,
      productGroup: [],
      product: [],
      lstScenarioCustomerGroups: CustObj.groupStr,
      lstScenarioCustomers: CustObj.unitStr,
      lstScenarioSKUs: prodObj.unitStr,
      lstScenarioProducts: prodObj.groupStr,
      criticalityId: criticalityId,
      userid: data.userID,
      roleName: data.roleName,
      scenarioDataSourceAlignment: scDSList, //editScDetails.scenarioDataSourceAlignment,
      isEdit: true,
      email: data.email,
      stickToQuota: selectedScSTQ === "Enabled" ? 1 : 0,
      effectiveStartDate: changeDateFormat(createFromDate),
      effectiveEndDate: changeDateFormat(createToDate),
      scenarioSafetyMargins: [
        {
          trustLevelID: 1,
          trustDesc: "High",
          safetyMargin: DSMHigh,
        },
        {
          trustLevelID: 2,
          trustDesc: "Medium",
          safetyMargin: DSMMed,
        },
        {
          trustLevelID: 3,
          trustDesc: "Low",
          safetyMargin: DSMLow,
        },
        {
          trustLevelID: 4,
          trustDesc: "Others/Customer Group",
          safetyMargin: DSMOth,
        },
      ],
      ScenarioSafetyMarginType: SafetyMargin,
      LinearFCTimePeriod: selectedLinearTrend,
      RunRateTimePeriod: selectedRunRate,
      FinancialFCTimePeriod: selectedConsensus,
      PreviousYearTimePeriod: selectedPreviousYear,
      QuotaDeviationPercentage: quotaDeviationPercentage,
      ModificationDeviationPercentage: modificationDeviationPercentage,
      DefaultInitialForecast: selectedDefaultInitialForecast,
      scenarioExternalDataSource: scenarioExternalDataSource,
      SKUExternalBreakdown: scenarioExternalDataSourceSKU,
      referenceSKUList: referenceSKUList,
      manuallyDefinedShare: manually_Defined,
      marketShareComparisonPeriod: MarketShareTimePeriod,
    };

    console.log("Edit_Summary_SubmitScenario", editSubmitData);
    dispatch(submitScenario(editSubmitData)).then(()=>{
      handleSearch();
    });
  };

  const handleSearch = () => {
		if(countryID == undefined ||countryID ==null || countryID == "") {
			showMessage("Please select country" , "info");
			return;
		}
		const fdate = "";
		const tdate = "";
		const obj = {
			countryId: countryID,
			scenario: search_ScenarioName,
			fromDate: search_FromDate == null ? fdate : changeDateFormat(search_FromDate),
			toDate: search_ToDate == null ? tdate : changeDateFormat(search_ToDate)
		};
		console.log("SearchScenario", obj);
		dispatch(getScenario(obj));
	};

  const getScenarioDatasourceFromDataSources = () => {
    let scenarioDatasources = [];
    selectedDSs.forEach((ds) => {
      dataSources.forEach((source) => {
        if (ds === source.dataSourceName) {
          scenarioDatasources.push(source);
        }
      });
    });
    return scenarioDatasources;
  };

  const handleSave = () => {
    clearErrors();
    if (!submitDataIsValid()) {
      return;
    }
    const CustObj = getIDsFromList(selectedCustsCGs, "C");
    const prodObj = getIDsFromList(selectedPGs, "P");
    const data = JSON.parse(localStorage.getItem("data"));
    const scDSList = prepareScenarioDSAlignment(prodObj);
    const manually_Defined = prepareManuallyDefinedShare();
    let referenceSKUList = "";
    if (selectedReferenceSKU.length === 0) {
      referenceSKUList = refList;
    } else {
      referenceSKUList = selectedReferenceSKU
        ?.filter((y) => y.id != 0)
        .map((x) => x.id)
        .join();
    }
    let userName = data.firstName + " " + data.lastName;
    let today = changeDateFormatforComments();
    let cmnts = comments;
    if (cmnts != undefined) {
      if (cmnts.indexOf(userName) <= 0)
        cmnts = cmnts + " (" + userName + ") " + today.toLocaleString();
    }
    const editSaveData = {
      scenarioID: editScID,
      effectiveStartDate: changeDateFormat(createFromDate),
      effectiveEndDate: changeDateFormat(createToDate),
      countryID: countryID,
      scenarioName,
      primaryDataSourceID,
      periodType,
      minimumQuota: minimumQuota,
      customerBreakdown,
      customerBreakdownType,
      skuBreakdown: skuBreakdown,
      defaultSafetyMargin: 0,
      isSendToSAPChecked: sentToSAP,
      sentToSAP: sentToSAP ? "N" : "NA",
      scenarioLevel: selectedCLID,
      emailNotification,
      comments: cmnts,
      notificationEmailAddress: email,
      scenarioStatus: "Draft",
      previousScenario: "",
      updatedBy: data.firstName + " " + data.lastName,
      updatedDate: changeDateFormat(dayjs()),
      createdBy: editScDetails.createdBy,
      createdDate: editScDetails.createdDate,
      approvedRejectedBy: editScDetails.approvedRejectedBy,
      SentToSAP4PLExport: sentToSAP ? 0 : 1,
      rejectionComments: editScDetails.rejectionComments,
      lstScenarioCustomerGroups: CustObj.groupStr,
      lstScenarioCustomers: CustObj.unitStr,
      lstScenarioProducts: prodObj.groupStr,
      lstScenarioSKUs: prodObj.unitStr,
      criticalityId: criticalityId,
      customers: [],
      customerGroups: [],
      productGroup: [],
      product: [],
      scenarioFiles: [],
      scenarioDataSources: null,
      scenarioDataSourceAlignment: scDSList,
      scenarioDatasource: getScenarioDatasourceFromDataSources(),
      userid: data.userID,
      email: data.email,
      roleName: data.roleName,
      isEdit: false,
      sentToSAP4PLExport: sentToSAP ? 0 : 1,
      scenarioSafetyMargins: [
        {
          trustLevelID: 1,
          trustDesc: "High",
          safetyMargin: DSMHigh,
        },
        {
          trustLevelID: 2,
          trustDesc: "Medium",
          safetyMargin: DSMMed,
        },
        {
          trustLevelID: 3,
          trustDesc: "Low",
          safetyMargin: DSMLow,
        },
        {
          trustLevelID: 4,
          trustDesc: "Others/Customer Group",
          safetyMargin: DSMOth,
        },
      ],
      stickToQuota: selectedScSTQ === "Enabled" ? 1 : 0,
      displayStickToQuota: selectedScSTQ === "Enabled" ? 1 : 0,
      tranOptions: editScDetails.tranOptions,
      ScenarioSafetyMarginType: SafetyMargin,
      LinearFCTimePeriod: selectedLinearTrend,
      RunRateTimePeriod: selectedRunRate,
      FinancialFCTimePeriod: selectedConsensus,
      PreviousYearTimePeriod: selectedPreviousYear,
      QuotaDeviationPercentage: quotaDeviationPercentage,
      ModificationDeviationPercentage: modificationDeviationPercentage,
      DefaultInitialForecast: selectedDefaultInitialForecast,
      scenarioExternalDataSource: scenarioExternalDataSource,
      SKUExternalBreakdown: scenarioExternalDataSourceSKU,
      referenceSKUList: referenceSKUList,
      manuallyDefinedShare: manually_Defined,
      marketShareComparisonPeriod: MarketShareTimePeriod,
    };
    console.log("Edit_Summary_SaveScenario", editSaveData);
    dispatch(saveScenario(editSaveData)).then(()=>{
      handleSearch();
    });
  };

  const handleVerify = () => {
    clearErrors();
    if (!submitDataIsValid()) {
      return;
    }
    const CustObj = getIDsFromList(selectedCustsCGs, "C");
    const prodObj = getIDsFromList(selectedPGs, "P");
    const data = JSON.parse(localStorage.getItem("data"));
    const scDSList = prepareScenarioDSAlignment(prodObj);
    const manually_Defined = prepareManuallyDefinedShare();
    let referenceSKUList = "";
    if (selectedReferenceSKU.length === 0) {
      referenceSKUList = refList;
    } else {
      referenceSKUList = selectedReferenceSKU
        ?.filter((y) => y.id != 0)
        .map((x) => x.id)
        .join();
    }
    let userName = data.firstName + " " + data.lastName;
    let today = changeDateFormatforComments();
    let cmnts = comments;
    if (cmnts != undefined) {
      if (cmnts.indexOf(userName) <= 0)
        cmnts = cmnts + " (" + userName + ") " + today.toLocaleString();
    }
    const verifyData = {
      scenarioID: editScID,
      effectiveStartDate: changeDateFormat(createFromDate),
      effectiveEndDate: changeDateFormat(createToDate),
      countryID: countryID,
      scenarioName,
      primaryDataSourceID,
      periodType,
      minimumQuota: minimumQuota,
      customerBreakdown,
      customerBreakdownType,
      skuBreakdown: skuBreakdown,
      defaultSafetyMargin: 0,
      isSendToSAPChecked: sentToSAP,
      sentToSAP: sentToSAP ? "N" : "NA",
      scenarioLevel: selectedCLID,
      emailNotification,
      comments: cmnts,
      notificationEmailAddress: email,
      previousScenario: "",
      updatedBy: data.firstName + " " + data.lastName,
      updatedDate: changeDateFormat(dayjs()),
      createdBy: editScDetails.createdBy,
      createdDate: editScDetails.createdDate,
      approvedRejectedBy: editScDetails.approvedRejectedBy,
      SentToSAP4PLExport: sentToSAP ? 0 : 1,
      rejectionComments: editScDetails.rejectionComments,
      lstScenarioCustomerGroups: CustObj.groupStr,
      lstScenarioCustomers: CustObj.unitStr,
      lstScenarioProducts: prodObj.groupStr,
      lstScenarioSKUs: prodObj.unitStr,
      criticalityId: criticalityId,
      customers: [],
      customerGroups: [],
      productGroup: [],
      product: [],
      scenarioFiles: [],
      scenarioDataSources: null,
      scenarioDataSourceAlignment: scDSList,
      scenarioDatasource: getScenarioDatasourceFromDataSources(),
      userid: data.userID,
      email: data.email,
      roleName: data.roleName,
      isEdit: false,
      sentToSAP4PLExport: sentToSAP ? 0 : 1,
      scenarioSafetyMargins: [
        {
          trustLevelID: 1,
          trustDesc: "High",
          safetyMargin: DSMHigh,
        },
        {
          trustLevelID: 2,
          trustDesc: "Medium",
          safetyMargin: DSMMed,
        },
        {
          trustLevelID: 3,
          trustDesc: "Low",
          safetyMargin: DSMLow,
        },
        {
          trustLevelID: 4,
          trustDesc: "Others/Customer Group",
          safetyMargin: DSMOth,
        },
      ],
      stickToQuota: selectedScSTQ === "Enabled" ? 1 : 0,
      displayStickToQuota: selectedScSTQ === "Enabled" ? 1 : 0,
      tranOptions: editScDetails.tranOptions,
      ScenarioSafetyMarginType: SafetyMargin,
      LinearFCTimePeriod: selectedLinearTrend,
      RunRateTimePeriod: selectedRunRate,
      FinancialFCTimePeriod: selectedConsensus,
      PreviousYearTimePeriod: selectedPreviousYear,
      QuotaDeviationPercentage: quotaDeviationPercentage,
      ModificationDeviationPercentage: modificationDeviationPercentage,
      DefaultInitialForecast: selectedDefaultInitialForecast,
      scenarioExternalDataSource: scenarioExternalDataSource,
      SKUExternalBreakdown: scenarioExternalDataSourceSKU,
      referenceSKUList: referenceSKUList,
      manuallyDefinedShare: manually_Defined,
      marketShareComparisonPeriod: MarketShareTimePeriod,
    };
    console.log("Edit_Summary_VerifyScenario", verifyData);
    dispatch(verifyScenario(verifyData)).then(()=>{
      handleSearch();
    });
  };

  useEffect(()=>{
    if(isCloneClicked === true){
      dispatch(setState('isCloneClicked',false));
      clearErrors();
      if (!submitDataIsValid()) {
        return;
      }
      const CustObj = getIDsFromList(selectedCustsCGs, "C");
      const prodObj = getIDsFromList(selectedPGs, "P");
      const data = JSON.parse(localStorage.getItem("data"));
      const scDSList = prepareScenarioDSAlignment(prodObj);
      const manually_Defined = prepareManuallyDefinedShare();
      let referenceSKUList = "";
      if (selectedReferenceSKU.length === 0) {
        referenceSKUList = refList;
      } else {
        referenceSKUList = selectedReferenceSKU
          ?.filter((y) => y.id != 0)
          .map((x) => x.id)
          .join();
      }
      let userName = data.firstName + " " + data.lastName;
      let today = changeDateFormatforComments();
      let cmnts = comments;
      if (cmnts != undefined) {
        if (cmnts.indexOf(userName) <= 0)
          cmnts = cmnts + " (" + userName + ") " + today.toLocaleString();
      }
      const cloneData = {
        scenarioID: editScID,
        effectiveStartDate: changeDateFormat(createFromDate),
        effectiveEndDate: changeDateFormat(createToDate),
        countryID: countryID,
        scenarioName,
        primaryDataSourceID,
        periodType,
        minimumQuota: minimumQuota,
        customerBreakdown,
        customerBreakdownType,
        skuBreakdown: skuBreakdown,
        defaultSafetyMargin: 0,
        isSendToSAPChecked: sentToSAP,
        sentToSAP: editScDetails.sentToSAP,
        scenarioLevel: selectedCLID,
        emailNotification,
        comments: cmnts,
        notificationEmailAddress: email,
        previousScenario: "",
        updatedBy: data.firstName + " " + data.lastName,
        updatedDate: changeDateFormat(dayjs()),
        createdBy: editScDetails.createdBy,
        createdDate: editScDetails.createdDate,
        approvedRejectedBy: editScDetails.approvedRejectedBy,
        SentToSAP4PLExport: sentToSAP ? 0 : 1,
        rejectionComments: editScDetails.rejectionComments,
        lstScenarioCustomerGroups: CustObj.groupStr,
        lstScenarioCustomers: CustObj.unitStr,
        lstScenarioProducts: prodObj.groupStr,
        lstScenarioSKUs: prodObj.unitStr,
        criticalityId: criticalityId,
        customers: [],
        customerGroups: [],
        productGroup: [],
        product: [],
        scenarioFiles: [],
        scenarioDataSources: null,
        scenarioDataSourceAlignment: scDSList,
        scenarioDatasource: getScenarioDatasourceFromDataSources(),
        userid: data.userID,
        email: data.email,
        roleName: data.roleName,
        isEdit: false,
        sentToSAP4PLExport: sentToSAP ? 0 : 1,
        scenarioSafetyMargins: [
          {
            trustLevelID: 1,
            trustDesc: "High",
            safetyMargin: DSMHigh,
          },
          {
            trustLevelID: 2,
            trustDesc: "Medium",
            safetyMargin: DSMMed,
          },
          {
            trustLevelID: 3,
            trustDesc: "Low",
            safetyMargin: DSMLow,
          },
          {
            trustLevelID: 4,
            trustDesc: "Others/Customer Group",
            safetyMargin: DSMOth,
          },
        ],
        stickToQuota: selectedScSTQ === "Enabled" ? 1 : 0,
        displayStickToQuota: selectedScSTQ === "Enabled" ? 1 : 0,
        tranOptions: editScDetails.tranOptions,
        ScenarioSafetyMarginType: SafetyMargin,
        LinearFCTimePeriod: selectedLinearTrend,
        RunRateTimePeriod: selectedRunRate,
        FinancialFCTimePeriod: selectedConsensus,
        PreviousYearTimePeriod: selectedPreviousYear,
        QuotaDeviationPercentage: quotaDeviationPercentage,
        ModificationDeviationPercentage: modificationDeviationPercentage,
        DefaultInitialForecast: selectedDefaultInitialForecast,
        scenarioExternalDataSource: scenarioExternalDataSource,
        SKUExternalBreakdown: scenarioExternalDataSourceSKU,
        referenceSKUList: referenceSKUList,
        manuallyDefinedShare: manually_Defined,
        marketShareComparisonPeriod: MarketShareTimePeriod,
      };
      console.log("Edit_Summary_CloneScenario", cloneData);
      dispatch(cloneScenario(cloneData)).then(()=>{
        dispatch(reset("cloneRefresh"));
      });
  }
  },[isCloneClicked])

  const handleClone = () => {
    dispatch(setState("openClonePopup",true));
  };
  const handleCopy = () => {
    dispatch(setStateCreate("scenarioID", 0));
    dispatch(setStateCreate("isCopyScenario", true));
    dispatch(setStateCreate("isLoading", false));
    dispatch(setStateCreate("sku_PG_Name", sku_PG_Name));
    dispatch(setStateCreate("productGroups", productGroups));
    dispatch(setStateCreate("selectedPGs", selectedPGs));
    dispatch(setStateCreate("selectedcustomerTypes", selectedcustomerTypes));
    dispatch(setStateCreate("selectedCustType", selectedCustType));
    dispatch(setStateCreate("selectedCTCode", selectedCTCode));
    dispatch(setStateCreate("selectedCL", selectedCL));
    dispatch(setStateCreate("selectedCLID", selectedCLID));
    dispatch(setStateCreate("breakDowns", breakDowns));
    dispatch(setStateCreate("selectedBD", selectedBD));
    dispatch(setStateCreate("breakDownTypes", breakDownTypes));
    dispatch(setStateCreate("selectedBDT", selectedBDT));
    dispatch(setStateCreate("selectedTL", selectedTL));
    dispatch(setStateCreate("selectedTLID", selectedTLID));
    dispatch(setStateCreate("customerName", customerName));
    dispatch(setStateCreate("custsCGs", custsCGs));
    dispatch(setStateCreate("selectedCustsCGs", selectedCustsCGs));
    dispatch(setStateCreate("selectedDSs", selectedDSs));
    dispatch(setStateCreate("selectedPDS", selectedPDS));
    dispatch(setStateCreate("selectedSKUBDM", selectedSKUBDM));
    dispatch(setStateCreate("selectedScSTQ", selectedScSTQ));
    dispatch(setStateCreate("selectedPG_SKU_ADSs", selectedPG_SKU_ADSs));
    dispatch(setStateCreate("selectedPG_SKU_ADSsID", selectedPG_SKU_ADSsID));
    dispatch(setStateCreate("DSAData", DSAData));
    dispatch(setStateCreate("scDSA", scDSA));
    dispatch(setStateCreate("scDSACopy", scDSACopy));
    dispatch(setStateCreate("editScDSAData", editScDSAData));
    dispatch(setStateCreate("DSAIdString", DSAIdString));
    dispatch(setStateCreate("DSAIdStringPrev", DSAIdStringPrev));
    dispatch(setStateCreate("skuBreakdown", skuBreakdown));
    dispatch(setStateCreate("customerBreakdownType", customerBreakdownType));
    dispatch(setStateCreate("customerBreakdown", customerBreakdown));
    dispatch(setStateCreate("MarketShareTimePeriod", MarketShareTimePeriod));
    dispatch(
      setStateCreate(
        "PreviousMarketShareTimePeriod",
        PreviousMarketShareTimePeriod
      )
    );
    dispatch(setStateCreate("scenarioName", scenarioName));
    // api payload for scenario
    dispatch(setStateCreate("primaryDataSourceID", primaryDataSourceID));
    dispatch(setStateCreate("minimumQuota", minimumQuota));
    dispatch(setStateCreate("comments", ""));
    dispatch(setStateCreate("lstScenarioCustomers", lstScenarioCustomers));
    dispatch(
      setStateCreate("lstScenarioCustomerGroups", lstScenarioCustomerGroups)
    );
    dispatch(setStateCreate("lstScenarioSKUs", lstScenarioSKUs));
    dispatch(setStateCreate("lstScenarioProducts", lstScenarioProducts));
    dispatch(
      setStateCreate("scenarioDataSourceAlignment", scenarioDataSourceAlignment)
    );
    dispatch(setStateCreate("scenarioStatus", scenarioStatus));
    dispatch(setStateCreate("editScName", editScName));
    dispatch(setStateCreate("editScenarioList", editScenarioList));
    dispatch(setStateCreate("editScID", editScID));
    dispatch(setStateCreate("editScDetails", editScDetails));
    dispatch(setStateCreate("message", message));
    dispatch(setStateCreate("severity", severity));
    dispatch(setStateCreate("messageOpen", messageOpen));
    dispatch(setStateCreate("selectedLinearTrend", selectedLinearTrend));
    dispatch(setStateCreate("selectedRunRate", selectedRunRate));
    dispatch(setStateCreate("selectedConsensus", selectedConsensus));
    dispatch(setStateCreate("selectedPreviousYear", selectedPreviousYear));
    dispatch(
      setStateCreate(
        "selectedDefaultInitialForecast",
        selectedDefaultInitialForecast
      )
    );
    dispatch(setStateCreate("editScDSAData", editScDSAData));
    dispatch(setStateCreate("localForecastAlignment", localForecastAlignment));
    dispatch(setStateCreate("periodType", periodType));
    dispatch(setStateCreate("emailNotification", emailNotification));
    dispatch(setStateCreate("criticalityId", criticalityId));
    dispatch(setStateCreate("SafetyMargin", SafetyMargin));
    dispatch(setStateCreate("selectedReferenceSKU", selectedReferenceSKU));
    dispatch(
      setStateCreate(
        "previousSelectedReferenceSKU",
        previousSelectedReferenceSKU
      )
    );
    dispatch(
      setStateCreate("marketShareComparisonList", marketShareComparisonList)
    );
    dispatch(
      setStateCreate(
        "previousMarketShareComparisonList",
        previousMarketShareComparisonList
      )
    );
    dispatch(setStateCreate("selectedRows", selectedRows));
    dispatch(setStateCreate("marketShareGraphData", marketShareGraphData));
    dispatch(
      setStateCreate(
        "previousMarketShareGraphData",
        previousMarketShareGraphData
      )
    );
    dispatch(setStateCreate("manually_defineMSList", manually_defineMSList));
    dispatch(
      setStateCreate("quotaDeviationPercentage", quotaDeviationPercentage)
    );
    dispatch(
      setStateCreate(
        "modificationDeviationPercentage",
        modificationDeviationPercentage
      )
    );
    dispatch(
      setStateCreate("scenarioExternalDataSource", scenarioExternalDataSource)
    );
    dispatch(
      setStateCreate(
        "scenarioExternalDataSourceSKU",
        scenarioExternalDataSourceSKU
      )
    );
    dispatch(setStateCreate("refList", refList));
    dispatch(setStateCreate("email", email));
    dispatch(setStateCreate("createToDate", createToDate));
    if(createFromDate > dayjs().add(1, "day")){
      dispatch(setStateCreate("createFromDate", createFromDate));
    }else{
      dispatch(setStateCreate("createFromDate", dayjs().add(1, "day")));
    }
    dispatch(setStateCreate("selectedCountry", selectedCountry));
    dispatch(setStateCreate("countryID", countryID));
    dispatch(setStateCreate("criticalityList", criticalityList));
    clearCountryDependents();
    getCountryDependents(countryID);
    let scenarioNameList = [];
    scenarioNameList.push(scenarioName);
    dispatch(SearchScenarioName(scenarioNameList));
    dispatch(setStateCreate("editMode", false));
  };
  const clearCountryDependents = () => {
    dispatch(setStateCreate("dataSources", []));
  };

  const getCountryDependents = (countryID) => {
    dispatch(getDataSources({ countryID }));
    dispatch(getCustGrpRef({ countryID }));
  };

  return (
    <Box>
      <CollapseSection title="Summary">
        <Box sx={{ mt: 3 }}>
          <Grid container spacing={2}>
            {/* <Grid item sm={12} md={12}>
						<Box sx={{mb: 2}}>
							<Typography className="compHeading">Summary</Typography>
						</Box>
					</Grid> */}
            <Grid
              item
              sm={12}
              md={12}
              sx={{ ml: "calc(100% - 120px)", mt: -4 }}
            >
              <ExportExcelPDF />
            </Grid>
          </Grid>
        </Box>

        <Box>
          <Box mb={1.2}>
            <Typography display="inline" sx={{ fontWeight: "600" }}>
              Scenario Name:{" "}
            </Typography>
            <Typography display="inline">{scenarioName}</Typography>
          </Box>
          <Box mb={1.2}>
            <Typography display="inline" sx={{ fontWeight: "600" }}>
              Country:{" "}
            </Typography>
            <Typography display="inline">{selectedCountry}</Typography>
          </Box>
          <Box mb={1.2}>
            <Typography display="inline" sx={{ fontWeight: "600" }}>
              Validity Period:{" "}
            </Typography>
            <Typography display="inline">
              {createFromDate === null
                ? ""
                : typeof createFromDate === "string"
                ? moment(createFromDate).format("DD/MM/YYYY")
                : moment(changeDateFormat(createFromDate)).format(
                    "DD/MM/YYYY"
                  )}{" "}
              To{" "}
              {createToDate === null
                ? ""
                : typeof createToDate === "string"
                ? moment(createToDate).format("DD/MM/YYYY")
                : moment(changeDateFormat(createToDate)).format("DD/MM/YYYY")}
            </Typography>
          </Box>
          <Box mb={1.2}>
            <Typography display="inline"  sx={{ fontWeight: "600" }}>
              Period Type:{" "}
            </Typography>
            <Typography display="inline">{periodType}</Typography>
          </Box>
          <Box mb={1.2}>
            <Typography sx={{ fontWeight: "600" }}>
              SKU(s):{" "}
            </Typography>
            <Typography
                sx={{ fontSize: "14px", mb: 2, cursor: "pointer" }}
                onClick={() => handleClickSKU("name")}
                display="inline"
              >
                Sort by Name |
              </Typography>{" "}
              <Typography
                sx={{ fontSize: "14px", mb: 2, cursor: "pointer" }}
                onClick={() => handleClickSKU("number")}
                display="inline"
              >
                Sort by Number
              </Typography>
            </Box>
            <Box  mb={1.2}>
            <TextField
                className={"fullHeight fullWidth"}
                overflow="scroll"
                multiline
                id="outlined-basic"
                label=""
                rows={6}
                variant="outlined"
                size="large"
                sx={{ "& .MuiMenuItem-root, .MuiInputBase-input":{
                   fontWeight: "400 !important"
                } }}
                value={listToNameStringSKUs(ProductList, "P")}
                style={{ overflowY: "auto" , fontWeight: "300 !important" }}
                InputProps={{ autoComplete: "off" }}
              />
          </Box>
          <Box mb={1.2}>
            <Typography display="inline"  sx={{ fontWeight: "600" }}>
              Product Group(s):
            </Typography>
            <Typography display="inline">
              {listToNameString(selectedPGs, "PG")}
            </Typography>
          </Box>
          <Box mb={1.2}>
            <Typography display="inline"  sx={{ fontWeight: "600" }}>
              Customer Group(s):
            </Typography>
            <Typography display="inline">
              {listToNameString(selectedCustsCGs, "CG")}
            </Typography>
          </Box>
          <Box>
            <Box>
              <Typography  sx={{ fontWeight: "600" }}>Customer(s):</Typography>
              {/* <Typography sx={{ fontWeight: "bold" }}  display="inline">
						{listToNameString(selectedCustsCGs, "C")}{" "}
					</Typography> */}
              <Typography
                sx={{ fontSize: "14px", mb: 2,  cursor: "pointer" }}
                onClick={() => handleClick("name")}
                display="inline"
              >
                Sort by Name |
              </Typography>{" "}
              <Typography
                sx={{ fontSize: "14px", mb: 2, cursor: "pointer" }}
                onClick={() => handleClick("number")}
                display="inline"
              >
                Sort by Number
              </Typography>
            </Box>
            <Box mb={1.2}>
              <TextField
                className={"fullHeight fullWidth"}
                overflow="hidden"
                multiline
                label=""
                readOnly
                rows={6}
                // sx={{
                // 	width: 1000,
                // 	height: 300,
                // }}
                sx={{ "& .MuiMenuItem-root, .MuiInputBase-input":{
                  fontWeight: "400 !important"
                } }}
                value={listToNameStringCustomers(CustomerList, "C")}
                style={{ overflowY: "auto" }}
                InputProps={{ autoComplete: "off" }}
              />
            </Box>
          </Box>
          <Box mb={1.2}>
            <Typography display="inline"  sx={{ fontWeight: "600" }}>
              Data Sources:{" "}
            </Typography>
            <Typography display="inline">{getDataSourcesString()}</Typography>
          </Box>
          <Box mb={1.2}>
            <Typography display="inline"  sx={{ fontWeight: "600" }}>
              Customer Breakdown Methodologies:{" "}
            </Typography>
            <Typography display="inline">
              {customerBreakdownType} {customerBreakdown}
            </Typography>
          </Box>
          <Box mb={1.2}>
            <Typography display="inline"  sx={{ fontWeight: "600" }}>
              SKU Breakdown Methodologies:{" "}
            </Typography>
            <Typography display="inline">{skuBreakdown}{" "}</Typography>
            {skuBreakdown !== undefined && skuBreakdown !== "" && skuBreakdown !=="External" && (<Typography display="inline">{customerBreakdown} </Typography>)}
          </Box>

          <Box mb={1}>
            <Typography sx={{ fontWeight: "600" }}>Comments</Typography>
          </Box>

          <Box mb={3}>
            <TextField
              className={"fullHeight fullWidth"}
              overflow="scroll"
              multiline
              id="outlined-basic"
              label=""
              rows={6}
              variant="outlined"
              size="large"
              value={comments}
              style={{ overflowY: "auto" }}
              sx={{ width: "100%", "& .MuiMenuItem-root, .MuiInputBase-input":{
                fontWeight: "400 !important"
              } }}
              onChange={(event) => handleStateUpdate(event, "comments")}
              InputProps={{ autoComplete: "off" }}
            />
          </Box>
        </Box>
      </CollapseSection>
      <Box
        sx={{
          diplay: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
        }}
      >
        {/* <Button
          item
          sm={2}
          startIcon={<CheckIcon />}
          disabled={isButtonDisable || !isRestrictedAccess}
          sx={{
            bgcolor: "skyBlue.main",
            color: "blue.main",
            textTransform: "none",
            mt: 2,
            mr: 2,
            "&:hover": {
              bgcolor: "lightBlue.main",
              color: "white.main",
            },
          }}
          onClick={handleVerify}
        >
          Verify Scenario
        </Button> */}

        {/* <Button
          disabled={isButtonDisable || !isRestrictedAccess}
          startIcon={<SaveIcon />}
          sx={{
            bgcolor: "skyBlue.main",
            color: "blue.main",
            textTransform: "none",
            mt: 2,
            "&:hover": {
              bgcolor: "lightBlue.main",
              color: "white.main",
            },
          }}
          onClick={handleSave}
        >
          Save Scenario
        </Button> */}

        {/* <Button item sm={2}
					startIcon={<ContentCopyIcon />}
					sx={{
						visibility: isCloneDisable ? "visible" : "hidden",
						bgcolor: "skyBlue.main",
						color: "blue.main",
						textTransform: "none",
						mt: 2,
						ml: 2,
						"&:hover": {
							bgcolor: "lightBlue.main",
							color: "white.main",
						},
					}}
					onClick={handleClone}
				>
					Clone Scenario
				</Button> */}
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row-",
          justifyContent: "flex-end",
          marginLeft: "auto",
        }}
      >
        {/* <Box>
					<Button
						disabled={isButtonDisable}
						startIcon={<SaveIcon />}
						sx={{
							bgcolor: "skyBlue.main",
							color: "blue.main",
							textTransform: "none",
							mt: 3,
							"&:hover": {
								bgcolor: "lightBlue.main",
								color: "white.main",
							},
						}}
						onClick={handleSave}
					>
						Save Scenario
					</Button>
				</Box> */}

        <Box>
          <Grid container spacing={2}>
            <Grid item>
                <Button
                  disabled={isButtonDisable || !isRestrictedAccess}
                  startIcon={<SaveIcon />} 
                  sx={{
                    bgcolor: "grey.lighter",
                    color: "darkred.light",
                    textTransform: "none",
                    mt: 3,
                    mr: 2,
                    "&:hover": {
                      bgcolor: "darkred.main",
                      color: "white.main",
                    },
                  }}
                  onClick={handleSave}
                >
                  Save Scenario
              </Button>
              <Button
                item
                sm={2}
                startIcon={<CheckIcon />}
                disabled={isButtonDisable || !isRestrictedAccess}
                sx={{
                  bgcolor: "grey.lighter",
                  color: "darkred.light",
                  textTransform: "none",
                  mt: 3,
                  mr: 2,
                  "&:hover": {
                    bgcolor: "darkred.main",
                    color: "white.main",
                  },
                }}
                onClick={handleVerify}
              >
                Verify Scenario
              </Button>
              <Button
                disabled={isButtonDisable || !isRestrictedAccess}
                startIcon={<FileUploadIcon />}
                sx={{
                  bgcolor: "darkred.light",
                  color: "white.main",
                  textTransform: "none",
                  mt: 3,
                  "&:hover": {
                    bgcolor: "darkred.main",
                    color: "white.main",
                  },
                }}
                onClick={handleSubmit}
                className="disabled"
              >
                Submit Scenario
              </Button>
            </Grid>
            {isCopyDisable && (
              <Grid item>
                <Button
                  startIcon={<FileUploadIcon />}
                  disabled={!isRestrictedAccess}
                  sx={{
                    bgcolor: "darkred.light",
                    color: "white.main",
                    textTransform: "none",
                    mt: 3,
                    "&:hover": {
                      bgcolor: "darkred.main",
                      color: "white.main",
                    },
                  }}
                  onClick={handleCopy}
                >
                  Copy Scenario
                </Button>
              </Grid>
            )}
            {isCloneDisable &&(
              <Grid item>
                <Button item sm={2}
                  startIcon={<ContentCopyIcon />}
                  disabled={!isRestrictedAccess}
                  sx={{
                    visibility: isCloneDisable ? "visible" : "hidden",
                    bgcolor: "darkred.light",
                    color: "white.main",
                    textTransform: "none",
                    mt: 3,
                    "&:hover": {
                      bgcolor: "darkred.main",
                      color: "white.main",
                    },
                  }}
                  onClick={handleClone}
                >
                  Clone Scenario
                </Button>
                </Grid>
            )}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}